'use es6';

import FileUploadRecord from 'conversations-internal-schema/file-upload/records/FileUploadRecord';
import { trackInteraction } from '../../usage-tracking/actions/trackInteraction';
import { validationErrorToTrackingFailureType } from '../../file-uploads/util/validationErrorToTrackingFailureType';
import { attachmentError } from '../../file-uploads/actions/attachmentError';
import { getThreadId } from '../../threads/operators/threadGetters';
import { validateAttachmentFile } from '../util/validateAttachmentFile';
import { uploadAttachment } from './uploadAttachment';
export const selectAttachmentFile = ({
  file,
  thread
}) => dispatch => {
  const threadId = getThreadId(thread);
  return validateAttachmentFile(file).then(() => {
    const attachment = new FileUploadRecord({
      file,
      progress: 0
    });
    return dispatch(uploadAttachment({
      attachment,
      threadId
    }));
  }).catch(error => {
    dispatch(attachmentError(error, threadId));
    dispatch(trackInteraction('failed-to-attach-file', {
      action: 'failed to attach file',
      'failure-type': validationErrorToTrackingFailureType(error)
    }));
  });
};